import { useSelector } from 'react-redux'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useOfferedRecipes } from 'hooks/menu-recipes/useOfferedRecipes'
import type { Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { locationQuery } from 'selectors/routing'

export const useInStockRecipeIds = (): Set<RecipeUUID> => {
  const offeredRecipes = Object.values(useOfferedRecipes())
  const availableRecipes = offeredRecipes
    .filter((recipe: Recipe) => recipe.isAvailable)
    .map((recipe: Recipe) => recipe.id)

  const { basketRecipes } = useBasketRecipes()
  const basketRecipeIds = basketRecipes.map((basketRecipe) => basketRecipe.id)

  const query = useSelector(locationQuery)
  const isAdmin = query && query['preview[menu_id]']

  const allRecipeIds = offeredRecipes.map((recipe: Recipe) => recipe.id)

  const inStockRecipeIds = isAdmin ? allRecipeIds : [...availableRecipes, ...basketRecipeIds]

  return new Set(inStockRecipeIds)
}
